var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 52,
    viewBox: "0 0 23 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5033_1616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2001 46.2097C21.6801 45.6697 21.1401 45.1297 20.7601 44.7497C18.5101 42.5297 17.1901 40.4097 16.0901 37.2797C14.0601 31.4097 14.0901 22.5997 16.1901 16.7297C17.2601 13.7097 19.3701 10.5697 21.4401 8.85975C21.8301 8.53975 22.0701 8.29974 22.2001 8.10975V7.53972C22.1901 7.53972 22.1801 7.52974 22.1701 7.52974C21.8101 7.63974 19.9701 9.32974 19.2801 10.1597C18.8601 10.6597 18.2601 11.4097 18.2601 11.4097C18.2601 11.4097 18.3101 9.65973 18.3101 7.91973C18.3101 5.00973 18.2601 4.75974 18.2601 4.75974C18.1201 4.75974 14.2201 5.69973 9.8401 6.79973L1.8501 8.79973V13.7297C1.8501 17.5997 1.8901 18.6297 2.0201 18.5797C2.3401 18.4797 6.8501 17.2197 6.9301 17.2197C6.9701 17.2197 7.0001 24.3097 7.0001 32.9697V48.7197H18.3001L18.2501 42.8897L19.8501 44.6797C20.6901 45.5397 21.6001 46.3697 21.8501 46.5597L22.1901 46.8697V46.2097H22.2001ZM17.7301 48.1597L12.6901 48.1297L7.6401 48.0897L7.5701 32.2497L7.4901 16.3997L5.0601 17.0897C3.7301 17.4797 2.5801 17.7297 2.5101 17.6797C2.4501 17.6197 2.4201 15.7197 2.4401 13.4397L2.4801 9.29973L10.0001 7.40974C14.1401 6.35975 17.6801 5.46973 17.7501 5.46973C17.7601 5.46973 17.7301 7.00974 17.7301 8.85975C17.7301 12.1697 17.7301 12.2397 17.3901 12.7697C15.7701 15.3497 14.5601 19.2397 14.1401 23.2097C13.8801 25.6997 14.0401 31.0597 14.4401 33.2797C14.9801 36.3697 15.9301 39.1097 17.2201 41.2997L17.7401 42.1697V48.1597H17.7301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5033_1616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2,
    height: 51.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.db6df323b95b2b0fc93985196c3d6b13.svg";
export { ForwardRef as ReactComponent };